import { render, staticRenderFns } from "./UpgradeAd.vue?vue&type=template&id=0a03b50f&scoped=true&"
import script from "./UpgradeAd.vue?vue&type=script&lang=js&"
export * from "./UpgradeAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03b50f",
  null
  
)

export default component.exports